module.exports = __webpack_public_path__ + "assets/webfonts/fa-regular-400.eot";